import React, { useEffect } from 'react';
import PlatformError from '@shared_modules/PlatformError/PlatformError';

const AccountValidation = props => {
  const { checkEmailErrors, updateUnloadPrompt, errors } = props;
  const error = checkEmailErrors?.[0] ?? errors?.find(err => err.error)?.error;

  useEffect(() => {
    if (updateUnloadPrompt) {
      updateUnloadPrompt(false);
    }
  }, []);

  return (
    <PlatformError
      heapTrackEventText="Main"
      heapTrackCustomEventName="Originations_Error_Page_Load"
      flowName="MAIN"
      status="Main Error"
      errorMessage={error}
    />
  );
};

export default AccountValidation;

